import React from 'react';
import { videoData } from '../assets/data/videoData';
import ScrollToTopButton from '../components/scrollTopButton';
import VideoPlayer from '../components/VideoPlayer';

const VideoPage = () => {
  return (
    <div className="px-4 sm:px-6 py-8 mt-32 w-full overflow-x-visible">
      {/* Container with forced left padding */}
      <div className="pl-2 sm:pl-0 w-full"> {/* Extra left padding for safety */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 w-full">
          {videoData.map((video, index) => (
            <div
              key={index}
              className="w-full"
            >
              <div className="w-full aspect-video overflow-hidden rounded-md shadow-md">
                <VideoPlayer
                  videoId={video.path}
                  size="small"
                  className="w-full h-full object-cover"
                />
              </div>
              <p className="mt-3 text-lg text-gray-700 text-center">{video.title}</p>
            </div>
          ))}
        </div>
      </div>
      <ScrollToTopButton />
    </div>
  );
};

export default VideoPage;